<div class="frame-container">
  <img class="frame-image" alt="" src="assets/app/media/img/misc/iphone_frame.png">
  <div class="frame" [style.background]="background">
    <div class="frame-contents" [ngStyle]="styleOverride">
      <ng-content></ng-content>
    </div>
    <img *ngIf="imageUri" [src]="imageUri" class="bgImg" style="z-index:0" />
    <ngx-loading [show]="isLoading"></ngx-loading>
  </div>
</div>